module.exports = __webpack_public_path__ + "assets/img/title-88a05c24.png";